import { useEffect, useState } from 'react'
import { fetchVisitorGeo, getFallbackGeo, VisitorGeo } from '../utils/geo'

/**
 * Resolves the visitor's country (via IP) so copy and social proof can be
 * localized. Starts from a timezone-based guess so nothing ever renders empty.
 */
export function useVisitorGeo(): VisitorGeo {
  const [geo, setGeo] = useState<VisitorGeo>(getFallbackGeo)
  useEffect(() => {
    let active = true
    fetchVisitorGeo()
      .then((resolved) => {
        if (active) setGeo(resolved)
      })
      .catch(() => {
        /* keep the fallback */
      })
    return () => {
      active = false
    }
  }, [])
  return geo
}
